import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/category/sukan", label: "速看" },
  { to: "/category/jingxuan", label: "精选" },
  { to: "/category/pianduan", label: "片段" },
  { to: "/category/tongqin", label: "通勤" },
  { to: "/category/shuiqian", label: "睡前" },
  { to: "/about", label: "关于我们" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-background-200/70"
          : "bg-background-50/70 backdrop-blur border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 md:h-[72px] items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-flashlight-fill text-lg"></i>
            </span>
            <span className="font-heading text-2xl text-foreground-950 group-hover:text-primary-600 transition-colors">
              抖漫
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `rounded-full px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/category/jingxuan"
              className="hidden sm:inline-flex items-center gap-2 rounded-full bg-accent-500 text-background-50 px-5 py-2 text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors"
            >
              <i className="ri-compass-3-line"></i>
              去逛逛
            </Link>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex md:hidden h-10 w-10 items-center justify-center rounded-full border border-background-200 text-foreground-800"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <nav className="md:hidden border-t border-background-200/70 bg-background-50/95 px-4 py-3 flex flex-col gap-1" aria-label="移动导航">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `rounded-lg px-4 py-2.5 text-sm font-medium ${
                  isActive ? "bg-primary-500 text-background-50" : "text-foreground-800 hover:bg-background-100"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}